import { V2CheckoutFragment } from "@stepapp/core";

type ParsedAnswer = {
  id: string;
  title: string;
  description: string;
  price: number;
  quantity: number;
};

export const getAttributeAnswers = (attributes: V2CheckoutFragment["attributes"]) => {
  return attributes?.filter(Boolean).map((a) => ({
    id: a?.attribute.id,
    title: a?.attribute.name || "",
    description: a?.values?.map((v) => v?.name).join("\n") || "",
    price: a?.price || 0,
    quantity: a?.quantity || 1,
  }));
};

export const getServiceAnswers = (services: V2CheckoutFragment["services"]) => {
  return (
    services?.reduce((acc, s) => {
      if (!s?.variants) return acc;

      for (const v of s.variants) {
        acc.push({
          id: v.variantId,
          title: s.service.name,
          description: `${v.quantity > 1 ? `${v.quantity}x ` : ""}${v.description || ""}`,
          price: (v?.isFree ? 0 : v.price) || 0,
          quantity: v.quantity,
        });
      }

      return acc;
    }, [] as ParsedAnswer[]) || []
  );
};
